<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  ~ Copyright (c) 2019. BMW Group. All rights reserved.
  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->

<app-generic-modal [primaryActionTitle]="primaryActionTitle"
                   [title]="title"
                   [primaryActionEnabled]="isValid"
                   (primaryActionEvent)="save()"
                   secondaryActionTitle="Discard">
    <div class="business-modal-body">

        <app-input-text #errorName
                        (inputValueChange)="nameInputChange($event)"
                        [messages]="nameMessages"
                        [validators]="validators.name"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        baseCypressTag="business-settings-error-modal-name"
                        label="Error code name"
                        maxLength="100"
                        placeholder="Please, write an error code name"></app-input-text>
        <app-input-text #errorCode
                        (inputValueChange)="codeInputChange($event)"
                        [messages]="codeMessages"
                        [validators]="validators.code"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        baseCypressTag="business-settings-error-modal-code"
                        label="Error code"
                        maxLength="3"
                        placeholder="Please, write an error code, e.g. 000"></app-input-text>
        <app-active-input (checkState)="setActiveInputState($event)" [entityName]="ENTITY_NAME"
                          [state]="$safeNavigationMigration(state?.isActive)"></app-active-input>

    </div>

</app-generic-modal>
